/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OrderPageStatus {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
}
